module.exports = __webpack_public_path__ + "static/media/04 Generali Auto OWU.787e8199.pdf";